export const en = {
    error_title: 'Something went wrong',
    error_description: 'Try reloading the page or contacting support if the error persists.',
    delete_travel_policy: 'Delete a travel policy',
    confirmation_delete_title: 'Confirmation',
    confirmation_delete_message: 'Are you sure you want to delete the travel policy?',
};
